import * as React from "react";
import type { SVGProps } from "react";
const SvgPendingArrowCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    viewBox="0 0 17 16" {...props}
  >
    <path
      stroke="#ED8822"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.374 4.963V2.664M12.673 2.663h-2.299M10.568 3.127a5.36 5.36 0 1 1-7.601 5.607M7.406 2.663a.033.033 0 1 1-.067 0 .033.033 0 0 1 .067 0M5.036 3.554a.033.033 0 1 1-.067 0 .033.033 0 0 1 .067 0M3.266 5.626a.033.033 0 1 1-.067 0 .033.033 0 0 1 .067 0"
    />
  </svg>
);
export default SvgPendingArrowCircle;
